import { takeLatest, put, call, select } from 'typed-redux-saga'
import { RequestParams, ResponseCatalog } from 'Models'
import { cityMqApi, citiesMqSelectors, City, cityNS, citySlice } from 'Pages/orders_design'
import { errorHandler } from 'Modules'
import { Deserialize } from 'cerialize'

function* getCities(action: cityNS.getCities) {
	try {
		const {
			params,
			options: { loadMore },
		} = action.payload
		let paramsForRequest: RequestParams
		if (params) {
			paramsForRequest = params
		} else {
			paramsForRequest = yield* select(citiesMqSelectors.getRequestParams)
		}
		const res = yield* call(cityMqApi.getItems, paramsForRequest)
		const city = new ResponseCatalog<City>(res)
		if (loadMore) {
			const oldCity = yield* select(citiesMqSelectors.getCities)
			city.entries = oldCity.entries.concat(city.entries)
		}
		yield* put(citySlice.actions.setCities(city))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getCitiesMissing(action: cityNS.getCitiesMissing) {
	try {
		const cities = yield* select(citiesMqSelectors.getCities)
		const res = yield* call(cityMqApi.getMissing, action.payload)
		cities.entries.push(Deserialize(res, City))
		yield* put(citySlice.actions.setCities(cities))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* citySaga() {
	yield* takeLatest(citySlice.actions.getCities.type, getCities)
	yield* takeLatest(citySlice.actions.getCitiesMissing.type, getCitiesMissing)
}
